import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";

class Contact extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const message = this.props.data.contactmessage;

    return (
      <section id="contact">
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Hubungi Saya.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">{message}</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="eight columns">
              <form action="" method="post" id="contactForm" name="contactForm">
                <fieldset>
                  <div>
                    <label htmlFor="contactName">
                      Nama <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactName"
                      name="contactName"
                    />
                  </div>

                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactEmail"
                      name="contactEmail"
                    />
                  </div>

                  <div>
                    <label htmlFor="contactSubject">Subjek</label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactSubject"
                      name="contactSubject"
                    />
                  </div>

                  <div>
                    <label htmlFor="contactMessage">
                      Pesan <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      id="contactMessage"
                      name="contactMessage"
                    ></textarea>
                  </div>

                  <div>
                    <button className="submit">Kirim</button>
                    <span id="image-loader">
                      <img alt="" src="images/loader.gif" />
                    </span>
                  </div>
                </fieldset>
              </form>

              <div id="message-warning">Mohon isi semua data dengan benar</div>
              <div id="message-success">
                <i className="fa fa-check"></i>Pesan Anda telah terkirim, terima kasih!
                <br />
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Alamat dan Telepon</h4>
                <p className="address">
                  {name}
                  <br />
                  {street} <br />
                  {city}, {state} {zip}
                  <br />
                  <span>{phone}</span>
                </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Informasi Terbaru</h4>
                <ul id="twitter">
                  <li>
                    <span>
                      Demo: Ini adalah contoh informasi terbaru yang ditampilkan secara statis. 
                      Konten ini adalah placeholder untuk keperluan demo.
                      <a href="#home">#demo</a>
                    </span>
                    <b>
                      <a href="#home">2 Hari Lalu</a>
                    </b>
                  </li>
                  <li>
                    <span>
                      Demo: Bagian ini menampilkan informasi statis sebagai pengganti feed Twitter. 
                      Semua konten bersifat demo dan tidak terhubung ke API eksternal.
                      <a href="#home">#demo</a>
                    </span>
                    <b>
                      <a href="#home">3 Hari Lalu</a>
                    </b>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Contact;
